<template>
  <div>
    <v-layout wrap justify-center pt-8>
      <v-flex>
        <div
          id="map"
          style="
            width: auto;
            height: 550px;
            position: relative;
            overflow: hidden;
          "
        ></div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script src="https://maps.googleapis.com/maps/api/js?key=AIzaSyB-wSOSvoBXfA5vn-23GR7OU5qTm8BFwlk&libraries=places,visualization,drawing"></script>
<script>
var marker;
let map, popup, Popup;
var myLatLng;
export default {
  props: ["storage", "placeList"],
  data() {
    return {
      map: "",
      mapData: [],
    };
  },
  mounted() {
    this.initMap();
  },
  methods: {
    initMap() {
      myLatLng = { lat: 10.8505, lng: 76.2711 };

      // myLatLng=this.storage
      map = new google.maps.Map(document.getElementById("map"), {
        center: { lat: 9.528484, lng: 76.824133 },
        zoom: 7,
      });
      this.plotMarker();
    },
    plotMarker() {
      // const iconBase = "https://developers.google.com/maps/documentation/javascript/examples/full/images/";
      const iconBase = require("./../../assets/images/studentIcon.png");
      const icons = {
        stops: {
          icon: iconBase,
        },
      };
      var features = [];
      var placeFeatures = [];
      var locs = [];
      if (this.storage) console.log("cco=", this.storage);

      // For marking All Places in trip
      for (let i = 0; i < this.placeList.length; i++) {
        var placeLat = this.placeList[i].placeId.location[1];
        var placeLon = this.placeList[i].placeId.location[0];
        var placeObj = {
          position: new google.maps.LatLng(placeLat, placeLon),
          title: this.placeList[i].placeId.name,
          // type: "stops",
        };
        var pobj = {
          lat: this.placeList[i].placeId.location[1],
          lng: this.placeList[i].placeId.location[0],
        };

        locs.push(JSON.parse(JSON.stringify(pobj)));

        placeFeatures.push(JSON.parse(JSON.stringify(placeObj)));
        // if (placeFeatures.length > 0)
        //   map = new google.maps.Map(document.getElementById("map"), {
        //     center: placeFeatures[0].position,
        //     zoom: 18,
        //   });
      }

      //For marking all students
      for (let i = 0; i < this.storage.length; i++) {
        var latitude = this.storage[i].location[1];
        var long = this.storage[i].location[0];
        var obj = {
          position: new google.maps.LatLng(latitude, long),
          title: this.storage[i].studentId.name,
          // type: "stops",
        };

        // var pobj = {
        //   lat: this.storage[i].location[1],
        //   lng: this.storage[i].location[0],
        // };

        // locs.push(JSON.parse(JSON.stringify(pobj)));

        features.push(JSON.parse(JSON.stringify(obj)));
        if (features.length > 0)
          map = new google.maps.Map(document.getElementById("map"), {
            center: features[0].position,
            zoom: 18,
          });
      }

      for (let i = 0; i < features.length; i++) {
        console.log("Fate", features[i]);
        const marker = new google.maps.Marker({
          position: features[i].position,
          map: map,
          title: features[i].title,
          // icon: icons[features[i].type].icon,
          icon: {
            url: iconBase,
            size: new google.maps.Size(36, 50),
            scaledSize: new google.maps.Size(36, 50),
            anchor: new google.maps.Point(0, 50),
          },
        });
      }
      for (let i = 0; i < placeFeatures.length; i++) {
        console.log("PlaceFate", placeFeatures[i]);
        const pmarker = new google.maps.Marker({
          position: placeFeatures[i].position,
          map: map,
          title: placeFeatures[i].title,
          // icon: icons[placeFeatures[i].type].icon,
        });
      }
      const flightPath = new google.maps.Polyline({
        path: locs,
        geodesic: true,
        strokeColor: "red",
        strokeOpacity: 1.0,
        strokeWeight: 1.5,
      });
      flightPath.setMap(map);
    },
  },
};
</script>
<style>
#map44 {
  height: 100%;
}
</style>
